$(function() {
    setTimeout(function() {
        function isTabletDeviceBig() {
            return window.innerWidth <= 767;
        }

        if (isTabletDeviceBig()) {
            $('.price-list-slider').slick({
                dots: true,
                infinite: false,
                speed: 300,
                slidesToShow: 1.6,
                variableWidth: true
            });
        }
    }, 500);
});
